import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6 col-sm container" }
const _hoisted_4 = { class: "row mt-3" }
const _hoisted_5 = { class: "col message" }
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "col message text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row mt-3" }, [
          _createElementVNode("div", { class: "col h-3" }, "ログアウトしました。")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.logoutMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickLink && _ctx.onClickLink(...args)), ["prevent","stop"])),
              class: "link"
            }, _toDisplayString(_ctx.sec) + "秒でログイン画面に移動します" + _toDisplayString(_ctx.dots), 1)
          ])
        ])
      ])
    ])
  ]))
}